export const dataUsuarios = [
    'Estudiante',
    'Docente',
    'Externo'
]